/**
 * Reusable rich text editor wrapper around ReactQuill, mirroring
 * viveka-ftw's src/custom-components/elements/rich-text-field/RichTextField.js
 * (separate repo/app, so this isn't literally shared code — same
 * toolbar/behaviour, kept consistent on purpose). Handles HTML entity
 * encoding/decoding internally so callers can just pass/receive HTML
 * strings.
 */
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { decode, encode } from 'html-entities'

const DEFAULT_MODULES = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
}

const DEFAULT_FORMATS = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'link']

interface PropsI {
  value: string
  onChange: (html: string) => void
  placeholder?: string
  readOnly?: boolean
}

const RichTextField = ({ value, onChange, placeholder, readOnly }: PropsI) => {
  const displayValue = decode(value || '')

  return (
    <ReactQuill
      theme="snow"
      placeholder={placeholder}
      value={displayValue}
      readOnly={readOnly}
      modules={DEFAULT_MODULES}
      formats={DEFAULT_FORMATS}
      onChange={(html) => onChange(encode(html))}
    />
  )
}

export default RichTextField
